// Constantes partagées pour le site ASHUD
export const ASHUD_INFO = {
  name: 'ASHUD Tchad',
  fullName: 'Action pour la Solidarité Humanitaire et le Développement',
  motto: 'Solidarité-Performance-Essor',
  slogan: 'La solidarité aux services du développement !',
  description: 'Organisation humanitaire œuvrant pour le développement durable au Tchad'
};

export const CONTACT_INFO = {
  phone: '+23561909132',
  phoneSecondary: '+23563090409',
  phonePresident: '+23591161364',
  email: 'info@ashud.org',
  emailSecretariat: 'secreteriat@ashud.org',
  address: {
    province: 'Province du Logone Occidental',
    city: 'Moundou',
    district: 'Quartier DOUMBEUR I',
    country: 'République du Tchad'
  }
};

export const NAVIGATION_LINKS = [
  { 
    path: '/', 
    label: 'Accueil', 
    icon: '🏠', 
    bgColor: 'bg-blue-100 group-hover:bg-blue-200',
    description: 'Page d\'accueil'
  },
  { 
    path: '/a-propos', 
    label: 'À propos', 
    icon: 'ℹ️', 
    bgColor: 'bg-green-100 group-hover:bg-green-200',
    description: 'Découvrez notre mission'
  },
  { 
    path: '/projets', 
    label: 'Nos Projets', 
    icon: '🚀', 
    bgColor: 'bg-purple-100 group-hover:bg-purple-200',
    description: 'Nos actions sur le terrain'
  },
  { 
    path: '/devenir-membre', 
    label: 'Devenir Membre', 
    icon: '🤝', 
    bgColor: 'bg-teal-100 group-hover:bg-teal-200',
    description: 'Rejoignez notre organisation'
  },
  { 
    path: '/contact', 
    label: 'Contact', 
    icon: '📞', 
    bgColor: 'bg-orange-100 group-hover:bg-orange-200',
    description: 'Contactez-nous'
  }
];

export const SOCIAL_LINKS = {
  facebook: 'https://facebook.com/profile.php?id=61560734369272',
  whatsapp: `https://wa.me/${CONTACT_INFO.phone.replace('+', '')}`
};

export const TEAM_MEMBERS = [
  {
    name: 'M. NGARKODJE MBAIGUEREM Mahamat',
    role: 'Président',
    phone: CONTACT_INFO.phonePresident,
    email: CONTACT_INFO.email,
    color: 'red'
  },
  {
    name: 'Mme NGARKODJE MBAIGUEREM Haoua',
    role: 'Secrétaire Générale',
    phone: CONTACT_INFO.phoneSecondary,
    email: CONTACT_INFO.emailSecretariat,
    color: 'green'
  },
  {
    name: 'M. MBAIGUEREM MORBE Justin',
    role: 'Conseiller Technique Principal',
    phone: CONTACT_INFO.phone,
    email: CONTACT_INFO.emailSecretariat,
    color: 'blue'
  }
];

// Utilitaires pour le formatage
export const formatPhoneNumber = (phone) => {
  return phone.replace('+235', '(+235) ').replace(/(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4');
};

export const formatAddress = (address) => {
  return `${address.province}, ${address.city}, ${address.district}, ${address.country}`;
};

// Constantes pour les animations et styles
export const ANIMATION_DURATIONS = {
  fast: 200,
  normal: 300,
  slow: 500
};

export const BREAKPOINTS = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px'
};
